import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiTablePagination: {
      defaultProps: {
        labelRowsPerPage: "表示件数",
        labelDisplayedRows: ({ from, to, count }) =>
          `${
            count !== -1
              ? `${count} 件中 / ${from} ～ ${to} 件目`
              : `${to} 以上`
          }`,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: "8.5px 14px",
        },
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
